import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { selectConfig, selectWork } from '../../Api/selectors';
import { generateOutgoingBpm, initiateNewOrder } from '../actions';
import { REQUEST_GENERATE_OUTGOING_BPM_INVOICE } from '../constants';
import styled from 'styled-components';
import { Button } from '../../../components/Buttons';
import { Loader } from '../../../components/Loader';
import { Modal, ModalControls } from '../../../components/Modal';
import { VBox } from '../../../components/Box';
import { FormField } from '../../../components/FormFields';
import { Input } from '../../../components/Form';
import { Permission } from '../../../components/Permission';
import { VEHICLE_ADD_OUTGOING_BPM_INVOICE } from '../../../components/Permission/constants';
import { Row } from '../../../components/List';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';
import styles from './VehicleOutgoingBPMInvoiceCard.module.css';

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
`;

const STATE = {
  showAddBpmModal: false,
  restBpmAmount: 0,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleOutgoingBPMInvoiceCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  handleOutgoingBPMClick = () => {
    this.to(`/invoices/${this.props.vehicle?.outgoing_bpm_invoice}`);
  };

  handleAddOutgoingBPMClick = () => {
    this.setState({ showAddBpmModal: true });
  };

  onReset() {
    this.setState({ ...STATE });
  }

  onRestBPMChange = e => {
    const { value } = e.target;
    this.setState({ restBpmAmount: value });
  };

  submitBpm = () => {
    const input = {
      restBPMAmount: this.state.restBpmAmount,
    };
    this.props.generateOutgoingBpm(this.props.vehicle?.id, input);
    this.setState({ showAddBpmModal: false, restBpmAmount: 0 });
  };

  formatAmount = function(amount) {
    let newAmount = amount.replace(',', '.');

    newAmount = parseFloat(newAmount);

    if (isNaN(newAmount)) {
      newAmount = null;
    }

    return newAmount;
  };

  renderAddBpmModal = () => (
    <Modal onClose={this.onReset.bind(this)} title={this.lbl('vehicle.order.bpm_invoice_modal_title')}>
      <VBox>
        <FormField label={this.lbl('vehicle.order.rest_bpm_amount')}>
          <Input
            name="bpm"
            type="text"
            step="0.01"
            min="0"
            value={this.state.restBpmAmount}
            onChange={this.onRestBPMChange}
          />
        </FormField>
      </VBox>
      <ModalControls>
        <Button small isPrimary onClick={this.onReset.bind(this)}>
          {this.lbl('cancel')}
        </Button>
        <Button small isPrimary onClick={this.submitBpm}>
          {this.lbl('ok')}
        </Button>
      </ModalControls>
    </Modal>
  );

  render() {
    if (this.props?.serverConfig?.disableBPMInvoices) return '';
    const { vehicle } = this.props;
    if (this.props.work) return <Loader small="true" />;
    if (vehicle?.outgoing_bpm_invoice || vehicle?.outgoing_invoice_in_helga === '1') {
      return this.renderOutgoingBPMInvoice();
    }

    return this.renderAddButton();
  }

  renderOutgoingBPMInvoice() {
    const { vehicle } = this.props;
    return (
      <Container>
        <div className={styles.containerButton}>
          <Button
            className={styles.buttonOpenModal}
            onClick={this.handleOutgoingBPMClick}
            disabled={vehicle?.outgoing_invoice_in_helga === '1'}
          >
            {this.lbl('vehicle.order.open_outgoing_bpm_invoice')}
          </Button>
        </div>
      </Container>
    );
  }

  renderAddButton() {
    this.renderAddBpmModal();
    const { vehicle } = this.props;
    return (
      <Container>
        <Permission permission={VEHICLE_ADD_OUTGOING_BPM_INVOICE}>
          <Row>
            {env.clientId !== AppClientId.HOOIKAMMER && (
              <div className={styles.containerButton}>
                <Button
                  className={styles.buttonOpenModal}
                  onClick={this.handleAddOutgoingBPMClick.bind(this)}
                  disabled={vehicle?.outgoing_invoice_in_helga === '1'}
                >
                  {this.lbl('vehicle.order.add_outgoing_bpm_invoice')}
                </Button>
              </div>
            )}
          </Row>
        </Permission>
        {this.state.showAddBpmModal && this.renderAddBpmModal()}
      </Container>
    );
  }
}

VehicleOutgoingBPMInvoiceCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_GENERATE_OUTGOING_BPM_INVOICE),
    serverConfig: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    init() {
      dispatch(initiateNewOrder());
    },
    generateOutgoingBpm(vehicleId, input) {
      dispatch(generateOutgoingBpm(vehicleId, input));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleOutgoingBPMInvoiceCard = compose(withConnect, withRouter)(VehicleOutgoingBPMInvoiceCardComp);
